"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var hooks_1 = require("../../../hooks");
var either_1 = require("../../../utils/either");
var components_1 = require("../components");
var Dropdown_1 = __importDefault(require("../inputs/Dropdown"));
var SubjektInfoDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  column-gap: 15px;\n"], ["\n  display: flex;\n  column-gap: 15px;\n"])));
var SubjektNazevDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  padding-bottom: 5px;\n"], ["\n  font-weight: bold;\n  padding-bottom: 5px;\n"])));
var SubjektDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 15px;\n"], ["\n  font-size: 15px;\n"])));
var renderSubjekt = function (nazev, druhOsoby) {
    return (react_1.default.createElement(SubjektDiv, null,
        react_1.default.createElement(SubjektNazevDiv, null, nazev),
        react_1.default.createElement(SubjektInfoDiv, null, druhOsoby)));
};
var mapSubjekt = function (subjekt) {
    var nazev = "" + (subjekt.jmeno && subjekt.prijmeni ? subjekt.jmeno + " " + subjekt.prijmeni : subjekt.nazev);
    return {
        value: subjekt.id,
        label: nazev,
        render: renderSubjekt(nazev, subjekt.druhOsoba),
    };
};
var SelectSubjektZasobnik = function (_a) {
    var _b;
    var name = _a.name;
    var _c = formik_1.useField(name), field = _c[0], helpers = _c[2];
    var isLoading = hooks_1.useBoolean();
    var zasobnikUrl = __1.useConfig().zasobnikUrl;
    var getJSON = hooks_1.useGetJSON(zasobnikUrl + "/SubjektSeek");
    var loadOptions = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var params, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchText) return [3 /*break*/, 2];
                    isLoading.setTrue();
                    params = {
                        keyword: searchText,
                    };
                    return [4 /*yield*/, getJSON(params)];
                case 1:
                    response = _a.sent();
                    isLoading.setFalse();
                    if (either_1.isRight(response)) {
                        return [2 /*return*/, response.value.map(function (sub) { return mapSubjekt(sub); })];
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, []];
            }
        });
    }); };
    return (react_1.default.createElement(components_1.Field, null,
        react_1.default.createElement(Dropdown_1.default, { isSearchable: true, name: "idSubjektu", value: (_b = field.value) === null || _b === void 0 ? void 0 : _b.id, placeholder: "Vyhledat subjekt", loadOptions: loadOptions, onChange: function (val) { return helpers.setValue({ id: val }); }, loading: isLoading.value })));
};
exports.default = SelectSubjektZasobnik;
var templateObject_1, templateObject_2, templateObject_3;
